import Layout from '../../Component/layout/main-layout'
import { useTranslation } from 'react-i18next'
import layoutBgImg from '../../Images/layout/others.jpg'
import GlobalLayout from '../../Component/layout/global-layout'

const Verify = () => {
    const { t } = useTranslation()

    return (
        <GlobalLayout
            title={`${t('verify')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords=""
        >
            <div className='mb-20'>
                <Layout
                    title={t('verify')}
                    layoutBgImg={layoutBgImg}
                />
                <div className='flex justify-center w-full'>
                    <div className='bg-white xl:p-8 mt-8 xl:w-[40%]
                                     dark:bg-dark-box w-[90%] p-4'>
                        <h1 className='text-center font-bold 
                                    dark:text-white mb-1 text-4xl'>
                            {t('verify')}
                        </h1>

                        {/* phone */}
                        <div className="relative mt-6">
                            <label className='flex items-center gap-1 text-sm
                            dark:text-dark-text'>
                                {t('code')}
                            </label>
                            <input
                                type="text"
                                name="phone"
                                placeholder={t('code')}
                                className="w-full px-4 py-2 border dark:text-dark-text
                                         border-border bg-secondary mb-2 mt-1 
                                           rounded focus:outline-none focus:ring-2 focus:ring-indigo-500   
                                         dark:bg-dark-box dark:border-dark-border"
                            />
                        </div>

                        <button
                            type="button"
                            className='text-white bg-primary px-6 
                                       mt-6 py-2 rounded w-full'
                        >
                            {t('verify_send')}
                        </button>

                        <p className='text-center hover:text-primary mt-6
                                      cursor-pointer  dark:text-white'>
                            {t('try')}
                        </p>
                    </div>
                </div>
            </div>
        </GlobalLayout>
    )
}

export default Verify